/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionEntity
 */
export interface SubscriptionEntity {
    /**
     * サブスクリプションID
     * @type {string}
     * @memberof SubscriptionEntity
     */
    id: string;
    /**
     * 
     * @type {object}
     * @memberof SubscriptionEntity
     */
    status: object;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionEntity
     */
    currentPeriodStart: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionEntity
     */
    currentPeriodEnd: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionEntity
     */
    cancelAt: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionEntity
     */
    canceledAt: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionEntity
     */
    cancelAtPeriodEnd: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionEntity
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionEntity
     */
    authTenantId: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionEntity
     */
    trial: string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionEntity
     */
    trialStart: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionEntity
     */
    trialEnd: number;
    /**
     * 
     * @type {Array<object>}
     * @memberof SubscriptionEntity
     */
    items: Array<object>;
}

/**
 * Check if a given object implements the SubscriptionEntity interface.
 */
export function instanceOfSubscriptionEntity(value: object): value is SubscriptionEntity {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('currentPeriodStart' in value) || value['currentPeriodStart'] === undefined) return false;
    if (!('currentPeriodEnd' in value) || value['currentPeriodEnd'] === undefined) return false;
    if (!('cancelAt' in value) || value['cancelAt'] === undefined) return false;
    if (!('canceledAt' in value) || value['canceledAt'] === undefined) return false;
    if (!('cancelAtPeriodEnd' in value) || value['cancelAtPeriodEnd'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('authTenantId' in value) || value['authTenantId'] === undefined) return false;
    if (!('trial' in value) || value['trial'] === undefined) return false;
    if (!('trialStart' in value) || value['trialStart'] === undefined) return false;
    if (!('trialEnd' in value) || value['trialEnd'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function SubscriptionEntityFromJSON(json: any): SubscriptionEntity {
    return SubscriptionEntityFromJSONTyped(json, false);
}

export function SubscriptionEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'status': json['status'],
        'currentPeriodStart': json['currentPeriodStart'],
        'currentPeriodEnd': json['currentPeriodEnd'],
        'cancelAt': json['cancelAt'],
        'canceledAt': json['canceledAt'],
        'cancelAtPeriodEnd': json['cancelAtPeriodEnd'],
        'description': json['description'],
        'authTenantId': json['authTenantId'],
        'trial': json['trial'],
        'trialStart': json['trialStart'],
        'trialEnd': json['trialEnd'],
        'items': json['items'],
    };
}

export function SubscriptionEntityToJSON(json: any): SubscriptionEntity {
    return SubscriptionEntityToJSONTyped(json, false);
}

export function SubscriptionEntityToJSONTyped(value?: SubscriptionEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': value['status'],
        'currentPeriodStart': value['currentPeriodStart'],
        'currentPeriodEnd': value['currentPeriodEnd'],
        'cancelAt': value['cancelAt'],
        'canceledAt': value['canceledAt'],
        'cancelAtPeriodEnd': value['cancelAtPeriodEnd'],
        'description': value['description'],
        'authTenantId': value['authTenantId'],
        'trial': value['trial'],
        'trialStart': value['trialStart'],
        'trialEnd': value['trialEnd'],
        'items': value['items'],
    };
}

